import React, { useState, useEffect } from 'react'
import axios from 'axios'
import ContentFilter from '../../../components/filter/contentFilter'
import AddCharacter from './add'
import EditCharacter from './edit'
import DeleteCharacter from './delete'
import MyIcon from '../../../components/general/icon'

export default function Character() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [characterList, setCharacterList] = useState([])
  const [propsData, setPropsData] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [isNextPage, setIsNextPage] = useState(0)
  const [isAddCharacterVisible, setIsAddCharacterVisible] = useState(false)
  const [isEditCharacterVisible, setIsEditCharacterVisible] = useState(false)
  const [isDeleteCharacterVisible, setIsDeleteCharacterVisible] = useState(false)

  const initialConditions = {
    column_oid: '',
    keywords: '',
    sort_filter: 0,
  }
  const [filterValue, setFilterValue] = useState(initialConditions)

  const getCharacterList = () => {
    setCurrentPage(1)
    setIsNextPage(0)
    axios.post('/p/content/character/list/get', { 
      merchant_oid: merchantOid,
      column_oid: filterValue.column_oid,
      keywords: filterValue.keywords,
      sort_filter: filterValue.sort_filter,
      page: 1, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setCharacterList(response.data.characters)
          if (response.data.total_page > 1) {
            setIsNextPage(1)
          }
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getCharacterList()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, filterValue])

  const loadNextPage = () => {
    setCurrentPage(page => page + 1)
    axios.post('/p/content/character/list/get', { 
      merchant_oid: merchantOid,
      column_oid: filterValue.column_oid,
      keywords: filterValue.keywords,
      sort_filter: filterValue.sort_filter,
      page: currentPage + 1, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          const newData = response.data.characters
          if (response.data.total_page <= currentPage + 1) {
            setIsNextPage(2)
          }
          setCharacterList(prevData => {
            const newDataIds = newData.map(item => item.oid)
            const filteredData = prevData.filter(item => !newDataIds.includes(item.oid))
            return [...filteredData, ...newData]
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const editCharacter = (oid) => {
    setIsEditCharacterVisible(true)
    setPropsData({ oid: oid })
  }

  const deleteCharacter = (oid, name) => {
    setIsDeleteCharacterVisible(true)
    setPropsData({ oid: oid, name: name})
  }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">人物列表</div>
          <ContentFilter
            addName='人物'
            category={4}
            filterValue={filterValue} 
            setFilterValue={setFilterValue} 
            isAddVisible={() => { setIsAddCharacterVisible(true) }}  
          />
        </div>

        <div className='public-main-style'>
          <div className='public-main-style2'>
            <table className='public-main-style2-item'>
              <thead>
                <tr className='public-main-style2-thead'>
                  <th style={{width: '300px'}}>
                    <div className='public-main-style2-title'>人物</div>
                  </th>
                  <th>所属栏目</th>
                  <th>排序</th>
                  <th style={{width: '50px'}}></th>
                </tr>
              </thead>

              <tbody>
                {characterList && (characterList.length > 0 ? (characterList.map((item) => (
                  <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { editCharacter(item.oid) }}>
                    <td style={{width: '300px'}}>
                      <div className='public-main-style2-tuwen'>
                        <img src={item.thumbnail} alt="" style={{width: '30px', height: '30px'}}/>
                        <span>{item.name}</span>
                      </div>
                    </td>
                    <td>{item.column_name}</td>
                    <td>{item.sort}</td>
                    <td style={{width: '50px'}}>
                      <div className='public-main-style2-operation-box'>
                        <div className='public-main-style2-operation' 
                          onClick={(event) => {event.stopPropagation(); deleteCharacter(item.oid, item.name)}}>
                          <MyIcon name='huishouzhan' />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))) : (
                  <tr className='public-main-style2-tbodyEmpty'>
                    <td colSpan='4'><span>暂无数据</span></td>
                  </tr>
                ))}
              </tbody>

              <tfoot>
                {isNextPage === 1 ? (
                  <tr className='public-main-style2-tfootNext'>
                    <td colSpan='4'>
                      <div className='public-main-style2-nextPage' onClick={loadNextPage}>下一页</div>
                    </td>
                  </tr>
                ) : ( isNextPage === 2 && 
                  <tr className='public-main-style2-tfootOver'>
                    <td colSpan='4'>已加载全部</td>
                  </tr>
                )}
              </tfoot>
            </table>
          </div>
        </div>
      </div>

      {isAddCharacterVisible && <AddCharacter
        getCharacterList={getCharacterList} 
        isOpen={isAddCharacterVisible} 
        isCancel={() => { setIsAddCharacterVisible(false) }} 
      />}

      {isEditCharacterVisible && <EditCharacter
        data={propsData}
        getCharacterList={getCharacterList} 
        isOpen={isEditCharacterVisible} 
        isCancel={() => { setIsEditCharacterVisible(false) }} 
      />}

      {isDeleteCharacterVisible && <DeleteCharacter
        data={propsData}
        getCharacterList={getCharacterList} 
        isOpen={isDeleteCharacterVisible} 
        isCancel={() => { setIsDeleteCharacterVisible(false) }} 
      />}
    </div>
  )
}
